import { render, staticRenderFns } from "./Pen.vue?vue&type=template&id=e62fb940&scoped=true&"
var script = {}
import style0 from "./Pen.vue?vue&type=style&index=0&id=e62fb940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62fb940",
  null
  
)

export default component.exports